import axios from 'axios';
import { useEffect, useState } from 'react';
import { Row, Col } from 'antd';
import Footer from '../component/Footer';
import CardItem from '../component/CardItem';

export default function Home() {
    const [dataTopic, setdataTopic] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchTopics = async () => {
        try {
            setLoading(true);
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/topic/getAll`, { params: { page: 1, pageSize: 12 } });
            setdataTopic(res?.data?.data || []);
            setLoading(false);
        } catch (err) {
            console.error('Failed to load topics', err);
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchTopics();
    }, []);

    return (
        <>
            <div className="min-h-screen bg-[#eef9ff] py-8">
              <div className="max-w-screen-2xl mx-auto p-6">
                {/* Topics first as requested */}
                <section className="mb-6">
                    <h2 className="text-3xl font-bold mb-4">Chương trình học chính</h2>
                    {loading ? (
                        <div className="py-10"><div className="flex justify-center"><div className="animate-spin rounded-full border-4 border-t-transparent border-blue-500 h-10 w-10"></div></div></div>
                    ) : (
                        <Row gutter={[20, 20]}>
                            {dataTopic.map((topic, index) => (
                                <Col xs={24} sm={12} md={8} xl={6} key={topic.id || index}>
                                    <CardItem
                                        to={'/course/' + topic.slug}
                                        title={topic.title}
                                        subtitle={topic.description}
                                        meta={`${topic.totalCourses || topic.total || 0} Bài học`}
                                        image={topic.image_url}
                                        imageAlt={topic.title}
                                        badge={topic.level || topic.tag}
                                    />
                                </Col>
                            ))}
                        </Row>
                    )}
                </section>

                <header className="py-8 text-center bg-[#eaf6fb] rounded-md mb-6">
                    <h1 className="text-4xl md:text-5xl font-extrabold text-gray-800">Chào mừng đến với <span className="text-blue-500">Effortless English</span></h1>
                    <p className="mt-2 text-gray-600">Học Tiếng Anh theo Phương Pháp Effortless English — Tự nhiên, dễ dàng và hiệu quả!</p>
                </header>

                {/* Method explanation section */}
                <section className="mb-8">
                    <h2 className="text-2xl font-semibold mb-4">Phương pháp Effortless English là gì?</h2>
                    <p className="text-gray-700 leading-7 mb-3">Effortless English là một phương pháp học tiếng Anh đặc biệt được phát triển bởi A.J. Hoge, tập trung vào việc học qua nghe và nói, giúp bạn xây dựng phản xạ tự nhiên với ngôn ngữ mà không cần lo lắng về ngữ pháp hay từ vựng khó nhớ.</p>
                    <p className="text-gray-700 leading-7">Với phương pháp này, bạn sẽ học tiếng Anh một cách tự nhiên, giống như cách bạn học tiếng mẹ đẻ, giúp bạn phát triển kỹ năng giao tiếp mà không bị căng thẳng hay lo lắng. <a className="text-blue-500" href="/method">[tìm hiểu thêm]</a></p>
                </section>

                {/* Benefits blue box */}
                <section className="mb-10 bg-[#eef9ff] p-8 rounded shadow-sm">
                    <div className="max-w-4xl mx-auto">
                        <h3 className="text-2xl font-semibold text-center mb-6">Lợi ích của việc học tiếng Anh qua Effortless English</h3>
                        <ul className="space-y-4 max-w-3xl mx-auto text-gray-700">
                            <li className="flex items-start gap-4">
                                <span className="flex-shrink-0 mt-1 inline-flex items-center justify-center w-8 h-8 rounded-full bg-blue-600 text-white">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M16.707 5.293a1 1 0 00-1.414-1.414L8 11.172 4.707 7.879a1 1 0 00-1.414 1.414l4 4a1 1 0 001.414 0l8-8z" clipRule="evenodd"/></svg>
                                </span>
                                <span>Tự nhiên và dễ dàng: Học tiếng Anh mà không phải lo lắng về ngữ pháp hay từ vựng.</span>
                            </li>
                            <li className="flex items-start gap-4">
                                <span className="flex-shrink-0 mt-1 inline-flex items-center justify-center w-8 h-8 rounded-full bg-blue-600 text-white">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M16.707 5.293a1 1 0 00-1.414-1.414L8 11.172 4.707 7.879a1 1 0 00-1.414 1.414l4 4a1 1 0 001.414 0l8-8z" clipRule="evenodd"/></svg>
                                </span>
                                <span>Phát triển kỹ năng nghe và nói: Luyện nghe và nói nhiều giúp bạn giao tiếp tự tin.</span>
                            </li>
                            <li className="flex items-start gap-4">
                                <span className="flex-shrink-0 mt-1 inline-flex items-center justify-center w-8 h-8 rounded-full bg-blue-600 text-white">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M16.707 5.293a1 1 0 00-1.414-1.414L8 11.172 4.707 7.879a1 1 0 00-1.414 1.414l4 4a1 1 0 001.414 0l8-8z" clipRule="evenodd"/></svg>
                                </span>
                                <span>Học mọi lúc, mọi nơi: Các bài học linh hoạt giúp bạn học bất kỳ khi nào và ở đâu.</span>
                            </li>
                            <li className="flex items-start gap-4">
                                <span className="flex-shrink-0 mt-1 inline-flex items-center justify-center w-8 h-8 rounded-full bg-blue-600 text-white">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M16.707 5.293a1 1 0 00-1.414-1.414L8 11.172 4.707 7.879a1 1 0 00-1.414 1.414l4 4a1 1 0 001.414 0l8-8z" clipRule="evenodd"/></svg>
                                </span>
                                <span>Không cần học ngữ pháp khô khan: Học tự nhiên qua nghe và nói mà không cần phải nhớ lý thuyết.</span>
                            </li>
                        </ul>
                    </div>
                </section>

                {/* Courses overview */}
                <section className="mb-8 text-center">
                    <h2 className="text-2xl font-semibold mb-2">Các khóa học tại Effortless English</h2>
                    <p className="text-gray-600 max-w-3xl mx-auto mb-6">Chúng tôi cung cấp các khóa học cho mọi trình độ – từ người mới bắt đầu đến những học viên đã có nền tảng vững vàng. Các bài học được thiết kế khoa học, giúp bạn tiến bộ nhanh chóng và hiệu quả.</p>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
                        <div className="bg-white p-6 rounded-lg shadow">
                            <h3 className="font-semibold text-lg mb-2">Khóa học cho người mới bắt đầu</h3>
                            <p className="text-gray-600 mb-3">Phù hợp với những ai muốn xây dựng nền tảng tiếng Anh vững chắc, học từ cơ bản đến nâng cao. <a className="text-blue-500" href="/course/beginners">[xem ngay]</a></p>
                        </div>
                        <div className="bg-white p-6 rounded-lg shadow">
                            <h3 className="font-semibold text-lg mb-2">Khóa học cho người muốn cải thiện</h3>
                            <p className="text-gray-600 mb-3">Dành cho học viên muốn cải thiện kỹ năng giao tiếp và nghe hiểu tiếng Anh ở mức độ cao hơn. <a className="text-blue-500" href="/course/intermediate">[xem ngay]</a></p>
                        </div>
                        <div className="bg-white p-6 rounded-lg shadow">
                            <h3 className="font-semibold text-lg mb-2">Khóa học chuyên đề</h3>
                            <p className="text-gray-600 mb-3">Các bài học tập trung vào tình huống giao tiếp cụ thể như công việc, du lịch và cuộc sống hàng ngày. <a className="text-blue-500" href="/course/special">[xem ngay]</a></p>
                        </div>
                    </div>
                </section>
              </div>
            </div>
            <Footer />
        </>
    );
};